"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const qcobjects_1 = require("qcobjects");
(0, qcobjects_1.RegisterWidgets)("layout-basic", "splash-screen", "github-grid", "octocat-icon", "lib-list");
(0, qcobjects_1.RegisterWidgets)("gitpod-button", "netlify-button", "aws-button", "github-button", "codespaces-button", "deploy-grid");
(0, qcobjects_1.RegisterWidget)("version-string");
